import { SplitFactory } from '@splitsoftware/splitio-browserjs';
import { IBrowserClient } from '@splitsoftware/splitio-browserjs/types/splitio';
import { DEFAULT_TREATMENT, FeatureFlagProvider } from './FeatureFlagProvider';

export class SplitFeatureFlagProvider implements FeatureFlagProvider {
  private _splitClient: IBrowserClient;

  constructor(splitClient: SplitIO.IBrowserClient) {
    this._splitClient = splitClient;
  }

  static createFromConfig(args: { authorizationKey: string; key: string }) {
    const splitFactory = SplitFactory({
      core: args,
    });

    const splitClient = splitFactory.client();
    return new SplitFeatureFlagProvider(splitClient);
  }

  getTreatment(featureName: string) {
    const treatment = this._splitClient.getTreatment(featureName);
    if (treatment === 'control') return DEFAULT_TREATMENT;
    return treatment;
  }

  onAvailable(callback: () => void): () => void {
    const onReadyFromCacheUnsubscribe = this._onReadyFromCache(callback);
    const onReadyUnsubscribe = this.onReady(callback);

    return () => {
      onReadyFromCacheUnsubscribe();
      onReadyUnsubscribe();
    };
  }

  private _onReadyFromCache(callback: () => void): () => void {
    this._splitClient.on(this._splitClient.Event.SDK_READY, callback);
    return () => this._splitClient.off(this._splitClient.Event.SDK_READY_FROM_CACHE, callback);
  }

  onReady(callback: () => void): () => void {
    this._splitClient.on(this._splitClient.Event.SDK_READY, callback);
    return () => this._splitClient.off(this._splitClient.Event.SDK_READY, callback);
  }

  onUpdate(callback: () => void): () => void {
    this._splitClient.on(this._splitClient.Event.SDK_UPDATE, callback);
    return () => this._splitClient.off(this._splitClient.Event.SDK_UPDATE, callback);
  }
}
